module.exports = __webpack_public_path__ + "static/media/qr.656ac6e2.jpg";